import GridColumn from "@/classes/component-classes/GridColumn";

export default class SearchPurchaseOrder {

    constructor() {

        this.gridColumns = [

            new GridColumn('', '', 'view', '78', true, false, 50),
            new GridColumn('1', 'PO Number', 'poNumber', '170', true, false, 50),
            new GridColumn('2', 'Job Number', 'jobNumber', '180', true, true, 50),
            new GridColumn('3', 'Shipper', 'shipper', '265', true, true, 50),
            new GridColumn('4', 'Conveyance', 'conveyance', '180', true, false, 40),
            new GridColumn('5', 'Container No.', 'containerNumber', '130', true, true, 50),
            new GridColumn('6', 'Container Type', 'containerType', '180', true, true, 50),
            new GridColumn('7', 'Pieces', 'nop', '40', true, false, 40),
            new GridColumn('8', 'Gross Weight', 'grossWeight', '80', true, true, 10),
            new GridColumn('9', 'Cube', 'cube', '70', true, true, 10),
            new GridColumn('10', 'Origin Port', 'originPort', '170', true, true, 10),
            new GridColumn('11', 'Destination Port', 'destinationPort', '170', true, true, 10),
            new GridColumn('12', 'Order Date', 'orderDate', '80', true, true, 10),
            new GridColumn('13', 'Ready Date', 'readyDate', '80', true, true, 10),
            new GridColumn('14', 'Departs', 'departs', '80', true, true, 10),
            new GridColumn('15', 'Arrives', 'arrives', '80', true, true, 10),
            new GridColumn('16', 'Delivery', 'delivery', '80', true, true, 10),
            new GridColumn('10', 'Order Status', 'orderStatus', '130', true, true, 10),


        ]

        this.poDummyData = [

            {

                poNumber: '234560',
                jobNumber: 'HE4359',
                shipper: 'Shipper Name',
                conveyance: 'Major Voyager',
                containerNumber: 'CN43638745',
                containerType: '20ft DV',
                pieces: '120',
                grossWeight: '123.00',
                cube: '55.36',
                originPort: 'CNSHA',
                destinationPort: 'THKKC',
                orderDate: '10 May 23',
                readyDate: '20 May 23',
                departs: '23 May 23',
                arrives: '29 May 23',
                delivery: '31 May 23',
                orderStatus: 'In Customs'

            },
            {

                poNumber: 'PO34434',
                jobNumber: 'HD12345',
                shipper: 'Greta Shipments',
                conveyance: 'Conveyance Detail',
                containerNumber: 'CN150763334',
                containerType: '20ft DV',
                pieces: '12',
                grossWeight: '113.00',
                cube: '15.36',
                originPort: 'HKHKG',
                destinationPort: 'THKKC',
                orderDate: '10 May 23',
                readyDate: '20 May 23',
                departs: '23 May 23',
                arrives: '29 May 23',
                delivery: '31 May 23',
                orderStatus: 'In Customs'

            },
            {

                poNumber: '234560',
                jobNumber: 'HE4359',
                shipper: 'Good Shipping Co',
                conveyance: 'Major Voyager',
                containerNumber: 'CN43638745',
                containerType: '20ft DV',
                pieces: '120',
                grossWeight: '123.00',
                cube: '55.36',
                originPort: 'CNSHA',
                destinationPort: 'THKKC',
                orderDate: '10 May 23',
                readyDate: '20 May 23',
                departs: '23 May 23',
                arrives: '29 May 23',
                delivery: '31 May 23',
                orderStatus: 'In Customs'

            },            {

                poNumber: '234560',
                jobNumber: 'HE4359',
                shipper: 'Shipper Name',
                conveyance: 'Major Voyager',
                containerNumber: 'CN43638745',
                containerType: '20ft DV',
                pieces: '120',
                grossWeight: '123.00',
                cube: '55.36',
                originPort: 'CNSHA',
                destinationPort: 'THKKC',
                orderDate: '10 May 23',
                readyDate: '20 May 23',
                departs: '23 May 23',
                arrives: '29 May 23',
                delivery: '31 May 23',
                orderStatus: 'In Customs'

            }



        ]
    }
}
